export default __webpack_public_path__ + "images/9X.996558c.png";